import React from "react";
import styled, {
  css,
  type FlattenSimpleInterpolation,
} from "styled-components";
import { ScreenSize } from "../breakpoint";
import { type ITextProps, TextAlignment, Variant } from "../TextProps";

interface IH2Props extends ITextProps {
  variant?: Variant.XLARGE | Variant.PRIMARY;
}

export const H2Styles = (props: IH2Props): FlattenSimpleInterpolation => {
  const textAlign = props.alignment ?? TextAlignment.LEFT;
  const color = props.textColor ?? "var(--colour-black)";
  const desktopFontSize =
    props.variant && props.variant === Variant.XLARGE ? "3.25rem" : "2.375rem";
  const mobileFontSize =
    props.variant && props.variant === Variant.XLARGE ? "2.25rem" : "1.875rem";
  const desktopLetterSpacing =
      props.variant && props.variant === Variant.XLARGE
          ? "0.0325rem"
          : "0.02375rem";
  const mobileLetterSpacing =
      props.variant && props.variant === Variant.XLARGE
          ? "0.0225rem "
          : "0.01875rem";

  return css`
    font-family: var(--font-helvetica);
    font-size: ${desktopFontSize};
    font-weight: 300;
    line-height: 1.15;
    letter-spacing: ${desktopLetterSpacing};
    text-transform: initial;
    text-align: ${textAlign};
    color: ${color};
    margin-bottom: 0;
  
    @media (max-width: ${ScreenSize.md}px) {
      font-size: ${mobileFontSize};
      line-height: 1.2;
      letter-spacing: ${mobileLetterSpacing};
    }
  `;
};

const StyledH2 = styled.h2<IH2Props>`
  ${H2Styles};
`;

export const H2: React.FC<IH2Props> = ({ tag = "h2", children, ...props }) => (
  <StyledH2 as={tag} {...props} data-component={"H2"}>
    {children}
  </StyledH2>
);

export default H2;
